export const environment = {
  production: false,
  staging: true, // ← clé manquante !
  envName: 'STAGE',
  API_BASE_URL: 'https://www.stageluhd.mana-web.com/api/v1/',
  BASE_URL: 'https://www.stageluhd.mana-web.com/',
  STRAPI_URL: 'https://cms.luxuryholidaysdirect.com',
  chatwootToken: 'FXYnQ99MBEtNDjSRAMkqcVuK',
  // Cle de SITE reCAPTCHA v3 (publique), depuis google.com/recaptcha/admin.
  // ATTENTION : elle doit etre de type « Score based (v3) ». Une cle v2 est
  // refusee par grecaptcha.execute() et bloquerait tous les formulaires.
  // La cle secrete, elle, vit cote API dans RECAPTCHA_SECRET_KEY.
  recaptcha: { siteKey: '6LfGR8ItAAAAALrCqfQDRTRwbyyouBSrqpLwKidA' },
};
